import React from "react";

export type TabOption = {
    label: string;
    id: string;
    value?: string;
};

type TabPillsProps = {
    label?: string; // ✅ NEW
    options: TabOption[];
    value: string;
    onChange: (value: string) => void;
    className?: string;
    innerClassName?: string
};

const TabPills: React.FC<TabPillsProps> = ({
    label,
    options,
    value,
    onChange,
    className = "",
    innerClassName = "",
}) => {
    return (
        <div className={`flex flex-col w-full ${className}`}>

            {/* ✅ Label */}
            {label && (
                <p className="text-md text-mainBrandColor mb-2">
                    {label}
                </p>
            )}

            {/* Pills */}
            <div className="flex gap-4 w-full">
                {options.map((item) => {
                    const isSelected = value === item.id;

                    return (
                        <button
                            key={item.id}
                            onClick={() => onChange(item.id)}
                            className={`flex-1 py-2 rounded-full text-sm font-semibold transition-all duration-200 border text-center
                ${isSelected
                                    ? "bg-[#6DBE45] text-white border-[#6DBE45] shadow-md"
                                    : "bg-white text-[#2F5E2E] border-[#A8D97B] hover:bg-[#A8D97B]/30"
                                }
                                ${innerClassName}`}
                        >
                            <div className="flex flex-col items-center">
                                <span>{item.label}</span>

                                {/* {item.value && (
                                    <span
                                        className={`text-[10px] ${isSelected
                                                ? "text-white/90"
                                                : "text-gray-500"
                                            }`}
                                    >
                                        {item.value}
                                    </span>
                                )} */}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default TabPills;